module.exports = __webpack_public_path__ + "assets/img/worldviewImgActive-c12eac84.png";